import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";
import MBasic from "./module/0_Basic";
import MProfile from "./module/1_profile";
import MThesis from "./module/2_thesis";
import MAnalysis from "./module/3_analysis";
import MyScholars from "./module/4_scholars";

class MyPageContent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: 'profile',
			// activeTab: 'thesis',
			// activeTab: 'analysis',
		}

		this.onUpdate = this.onUpdate.bind(this);
	}

	changeTab = (id) => {
		this.setState({
			activeTab: id
		})
	}

	onUpdate(record) {
		this.props.onUpdate(record);
		this.forceUpdate();
	}

	render() {
		const record = this.props.record;

		if (!record || Object.keys(record).length === 0)
			return (
				<div className="center-group">
					<div className="row">
						<div className="col">
							<div className="square-card-item">
								<div className="text-center">
									<p className="font-weight-bold">연구자의 프로파일이 존재하지 않습니다.</p>
									<p>연구자의 논문이 아직 구축되지 않았거나 프로파일이 생성되지 않았습니다.<br />
										관련 문의는 1:1문의 게시판 또는 사이트 하단의 연락처로 문의하여 주시기 바랍니다.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		if (Object.keys(record).length <= 0)
			return '';

		return (
			<div className="center-group">
				<MBasic record={record} onUpdate={this.onUpdate}/>
				<div className="mt-px-40">
					<div className="page-tab full">
						<div className="page-tab-inner">
							<div className="container">
								<ul className="nav">
									<li className="nav-item" onClick={() => this.changeTab('profile')}>
										<button
											className={"nav-link " + (this.state.activeTab === 'profile' ? 'active' : '')}
											type="button">프로필
										</button>
									</li>
									<li className="nav-item" onClick={() => this.changeTab('thesis')}>
										<button
											className={"nav-link " + (this.state.activeTab === 'thesis' ? 'active' : '')}
											type="button">나의 논문
										</button>
									</li>
									<li className={"nav-item " + (this.state.activeTab === 'analysis' ? 'active' : '')}
										onClick={() => this.changeTab('analysis')}>
										<button
											className={"nav-link " + (this.state.activeTab === 'analysis' ? 'active' : '')}
											type="button">성과분석
										</button>
									</li>
									<li className={"nav-item " + (this.state.activeTab === 'scholars' ? 'active' : '')}
										onClick={() => this.changeTab('scholars')}>
										<button
											className={"nav-link " + (this.state.activeTab === 'scholars' ? 'active' : '')}
											type="button">선호 연구자
										</button>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="tab-content">
						{this.state.activeTab === 'profile' &&
							<MProfile record={record}/>
						}
						{this.state.activeTab === 'thesis' &&
							<MThesis record={record}/>
						}
						{this.state.activeTab === 'analysis' &&
							<MAnalysis record={record}/>
						}
						{this.state.activeTab === 'scholars' &&
							<MyScholars />
						}
					</div>
				</div>
				{/*<div aria-live="polite" aria-atomic="true" style={{position: "relative",minHeight: "200px"}}>*/}
				{/*	<div className="toast" style={{position: "absolute", top: "0", right: "0", opacity : 1}}>*/}
				{/*		<div className="toast-header">*/}
				{/*			<img src="..." className="rounded mr-2" alt="..."/>*/}
				{/*			<strong className="mr-auto">Bootstrap</strong>*/}
				{/*			<small>11 mins ago</small>*/}
				{/*			<button type="button" className="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">*/}
				{/*				<span aria-hidden="true">&times;</span>*/}
				{/*			</button>*/}
				{/*		</div>*/}
				{/*		<div className="toast-body">*/}
				{/*			Hello, world! This is a toast message.*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*</div>*/}
			</div>
		)
	}
}

export default MyPageContent;

MyPageContent.propTypes = {
	// args : PropTypes.object,
	// facet : PropTypes.object,
};
